// N2 (rà soát người dùng 05/10): duyệt = bot ĐĂNG THẬT, không hoàn tác. Mọi nút duyệt ngoài trang Chờ duyệt (dải "Cần bạn", thẻ bot, "Duyệt các bot
// đã tick") và "Duyệt tất cả" phải HIỆN câu sẽ đăng + bài đích rồi hỏi lại; Super duyệt câu của Boss KHÁC phải tick "duyệt thay" mới bấm được.
// Hộp dùng chung lớp modal-wrap + data-testid "confirm"/"confirm-ok"/"confirm-cancel" như confirmBox (đổi trang / Esc đóng hộp = Huỷ).
import { api, ApiError, errMsg } from "./api";
import { h } from "./dom";
import { cauCuaBossKhac, conLaiChoDuyet, motDong } from "./logic-bot-duyet";
import type { ChoDuyetItem, ChoDuyetView } from "../../../src/shared/kich-ban-tu-sua";
import type { Run } from "./types";
import { lamSachMa } from "../../../src/shared/ten-ma-noi-bo"; // đợt B3

/** Danh sách câu đang chờ duyệt (máy chủ: mọi bước rủi ro cao đang chờ của bot mình; Super: mọi Boss, kèm ownerName). */
export async function taiCauChoDuyet(): Promise<ChoDuyetItem[]> {
  return (await api<ChoDuyetView>("GET", "/api/cho-duyet")).items;
}

/** Câu đang chờ của MỘT lần chạy dựng từ bản ghi lần chạy (khi danh sách Chờ duyệt chưa có nó — vd máy chủ cũ). null = không còn chờ. */
async function cauTuLanChay(runKey: string, ownerName: string | null): Promise<ChoDuyetItem | null> {
  const r = await api<Run>("GET", `/api/runs/${encodeURIComponent(runKey)}`);
  const p = r.status === "paused_approval" ? r.record?.pending ?? r.pending : undefined;
  if (!p) return null;
  return { runKey: r.key, botId: r.botId, botName: r.botName, ownerName, bundleName: r.bundleName, kichBanId: null, kichBanTen: null, jobId: r.jobId, stepId: p.stepId,
    moTa: p.description, noiDung: p.noiDung ?? null, askedAt: p.askedAt, baiDich: p.baiDich ?? null, nenTang: null, gioiHanKyTu: 5000, anh: p.anh ? { ten: p.anh.ten, url: p.anh.url } : null, hetHanLuc: null };
}

/** Câu đang chờ của các lần chạy cho trước (giữ thứ tự; lần chạy không còn chờ thì bỏ). */
export async function cauCuaLanChay(ds: { runKey: string; ownerName: string | null }[]): Promise<ChoDuyetItem[]> {
  const theoKhoa = new Map((await taiCauChoDuyet()).map((it) => [it.runKey, it]));
  const out: ChoDuyetItem[] = [];
  for (const d of ds) {
    const it = theoKhoa.get(d.runKey) ?? (await cauTuLanChay(d.runKey, d.ownerName).catch(() => null));
    if (it) out.push(it);
  }
  return out;
}

/** Một dòng "bài đích" (tác giả — trích nội dung + liên kết mở bài) hoặc câu báo chưa rõ bài. */
export function dongBaiDich(it: Pick<ChoDuyetItem, "baiDich" | "runKey">, toiDa = 90): HTMLElement {
  const bd = it.baiDich;
  if (!bd || (!bd.tacGia && !bd.noiDung && !bd.url)) {
    return h("span", { class: "small muted dh-khong-bai", "data-testid": "dh-khong-bai" }, "Chưa rõ bài đích (bot không gửi địa chỉ bài) — ",
      h("a", { href: `#/runs/${encodeURIComponent(it.runKey)}`, title: "Mở chi tiết lần chạy: ảnh màn hình lúc bot dừng chờ duyệt" }, "xem ảnh màn hình"));
  }
  return h("span", { class: "small dh-bai", "data-testid": "dh-bai" }, h("span", { class: "muted" }, "Vào bài: "),
    bd.tacGia ? h("b", {}, bd.tacGia) : null, bd.noiDung ? ` — ${motDong(bd.noiDung, toiDa)}` : null,
    bd.url ? [" ", h("a", { href: bd.url, target: "_blank", rel: "noopener noreferrer", title: "Mở bài trong tab mới" }, "mở bài ↗")] : null);
}

/**
 * Hộp xác nhận "Đăng thật N câu?" liệt kê từng câu (đúng chữ sẽ gửi), bot, bài đích, ảnh kèm, hạn duyệt. `cau` = câu người dùng đã sửa (theo runKey).
 * Trả true khi người dùng bấm Duyệt. Có câu của Boss khác (Super) → ô "Tôi duyệt thay…" phải tick thì nút Duyệt mới bật.
 */
export function hopDuyet(items: ChoDuyetItem[], opts: { toi: string | null | undefined; cau?: Map<string, string> }): Promise<boolean> {
  const n = items.length;
  const khac = cauCuaBossKhac(items, opts.toi);
  return new Promise((resolve) => {
    const xong = (v: boolean) => { wrap.remove(); resolve(v); };
    const ok = h("button", { type: "button", class: "ok", "data-testid": "confirm-ok", title: "Cho bot đăng/gửi THẬT đúng các câu trong hộp này — không hoàn tác được", onclick: () => xong(true) }, n === 1 ? "Duyệt & đăng" : `Duyệt & đăng ${n} câu`);
    const thay = h("input", { type: "checkbox", "data-testid": "confirm-thay-boss" }) as HTMLInputElement;
    if (khac.length) { ok.disabled = true; thay.addEventListener("change", () => { ok.disabled = !thay.checked; }); }
    const now = Date.now();
    const ds = h("ol", { class: "dh-ds", "data-testid": "dh-ds" }, ...items.map((it) => {
      const cau = opts.cau?.get(it.runKey) ?? it.noiDung;
      const han = conLaiChoDuyet(it.hetHanLuc, now);
      return h("li", { class: "dh-muc", "data-testid": "dh-muc", dataset: { runKey: it.runKey } },
        h("div", { class: "dh-dau" }, h("b", { class: "wrap" }, it.botName), it.ownerName ? h("span", { class: `tag${it.ownerName !== opts.toi ? " warn" : ""}`, "data-testid": "dh-boss" }, `Boss ${it.ownerName}`) : null,
          han ? h("span", { class: `small ${han.gap ? "warn" : "muted"}` }, han.chu) : null),
        cau !== null && cau !== undefined
          ? h("div", { class: "dh-cau wrap", "data-testid": "dh-cau" }, cau)
          : h("div", { class: "small muted wrap", "data-testid": "dh-cau" }, `(Không gõ chữ — bot sẽ: ${motDong(lamSachMa(it.moTa), 160)})`),
        it.anh ? h("div", { class: "small muted wrap" }, `Kèm ảnh: ${it.anh.ten}`) : null,
        dongBaiDich(it));
    }));
    const wrap = h("div", { class: "modal-wrap", role: "dialog", "aria-modal": "true", "data-testid": "confirm" },
      h("div", { class: "modal dh-modal" },
        h("h3", {}, n === 1 ? "Đăng thật câu này?" : `Đăng thật ${n} câu?`),
        h("p", { class: "small" }, "Bot sẽ đăng/gửi ", h("b", {}, "THẬT"), " đúng các câu dưới đây ngay khi bạn bấm — không hoàn tác được. Muốn sửa câu thì bấm Huỷ rồi sửa ở trang ", h("a", { href: "#/cho-duyet" }, "Chờ duyệt"), "."),
        khac.length ? h("div", { class: "warn-box", "data-testid": "confirm-boss-khac" },
          `⚠ Có câu của Boss khác (${khac.join(", ")}) — bạn đang duyệt THAY họ.`,
          h("label", { class: "inline dh-thay" }, thay, `Tôi duyệt thay ${khac.join(", ")}`)) : null,
        ds,
        h("div", { class: "row end" },
          h("button", { type: "button", "data-testid": "confirm-cancel", title: "Đóng hộp, không duyệt gì", onclick: () => xong(false) }, "Huỷ"), ok)));
    wrap.addEventListener("keydown", (e) => { if (e.key === "Escape") xong(false); });
    wrap.addEventListener("dong-hop", () => resolve(false));
    document.body.appendChild(wrap);
    (wrap.querySelector('[data-testid="confirm-cancel"]') as HTMLButtonElement | null)?.focus();
  });
}

/** Duyệt ĐÚNG câu đã hiện cho người dùng (askedAt — câu đổi giữa chừng thì máy chủ từ chối, không duyệt nhầm). */
export async function guiDuyetCau(it: ChoDuyetItem, cau?: string): Promise<{ kq: "ok" | "da_xu_ly" | "loi"; loi?: string }> {
  try {
    await api("POST", `/api/runs/${encodeURIComponent(it.runKey)}/approve`, { approved: true, askedAt: it.askedAt, ...(it.noiDung !== null && cau !== undefined ? { noiDung: cau } : {}) });
    return { kq: "ok" };
  } catch (e) {
    return { kq: e instanceof ApiError && e.code === "conflict" ? "da_xu_ly" : "loi", loi: `${it.botName}: ${errMsg(e)}` };
  }
}

/** Duyệt lần lượt các câu đã xác nhận → chữ tóm tắt cho toast. */
export async function duyetLanLuot(items: ChoDuyetItem[], cau?: Map<string, string>): Promise<{ n: number; daXuLy: number; loi: string[] }> {
  let n = 0, daXuLy = 0;
  const loi: string[] = [];
  for (const it of items) {
    const r = await guiDuyetCau(it, cau?.get(it.runKey));
    if (r.kq === "ok") n++; else if (r.kq === "da_xu_ly") daXuLy++; else loi.push(r.loi ?? it.botName);
  }
  return { n, daXuLy, loi };
}
export function chuKetQuaDuyet(r: { n: number; daXuLy: number; loi: string[] }): string {
  return `Đã duyệt ${r.n} câu${r.daXuLy ? ` · ${r.daXuLy} câu đã được xử lý ở nơi khác` : ""}${r.loi.length ? ` · ${r.loi.length} câu lỗi (${r.loi.join("; ")})` : ""}`;
}
